import { routeNames } from "constant/routes";
import { useLocation } from "react-router-dom";

const useIsFullscreenDashboard = () => {
  const { pathname } = useLocation();
  return pathname === routeNames.APP_DASHBOARD_FULLSCREEN;
};

export default useIsFullscreenDashboard;
